import { useState, useEffect } from "react";
import { toast } from "sonner";
import { KeyRound, Hash } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

const inp = "w-full bg-[#050505] border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-[#666] focus:border-white/40 focus:outline-none transition-colors duration-300";

export default function SettingsView() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const [counter, setCounter] = useState(null);
  const [nextNumber, setNextNumber] = useState("");
  const [savingCounter, setSavingCounter] = useState(false);

  useEffect(() => { api.get("/admin/customer-counter").then((r) => setCounter(r.data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 6) { toast.error("Neues Passwort muss mind. 6 Zeichen haben."); return; }
    if (nw !== confirm) { toast.error("Die neuen Passwörter stimmen nicht überein."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Passwort erfolgreich geändert.");
      setCur(""); setNw(""); setConfirm("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Änderung fehlgeschlagen.");
    } finally { setSaving(false); }
  };

  const saveCounter = async (e) => {
    e.preventDefault();
    const n = parseInt(nextNumber, 10);
    if (!n || n < 1) { toast.error("Bitte eine gültige Nummer eingeben."); return; }
    setSavingCounter(true);
    try {
      const { data } = await api.put("/admin/customer-counter", { next_number: n });
      toast.success(`Nächste Kundennummer ist jetzt ${data.next_customer_number}.`);
      setCounter({ current_seq: n - 1, next_customer_number: data.next_customer_number });
      setNextNumber("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Speichern fehlgeschlagen.");
    } finally { setSavingCounter(false); }
  };

  return (
    <div data-testid="settings-view">
      <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl mb-3">Einstellungen</h1>
      <p className="text-[#999] mb-8 max-w-xl">Ändere hier dein Admin-Passwort. Es gilt sofort für die nächste Anmeldung.</p>

      <form onSubmit={submit} data-testid="password-form" className="max-w-md rounded-3xl border border-white/10 bg-[#0a0a0a] p-8 space-y-5 mb-8">
        <div className="w-12 h-12 rounded-full border border-white/15 flex items-center justify-center text-white mb-2"><KeyRound size={20} /></div>
        <div>
          <label className="block text-xs font-mono uppercase tracking-widest text-[#888] mb-2">Aktuelles Passwort</label>
          <input data-testid="cur-password" type="password" required value={cur} onChange={(e) => setCur(e.target.value)} placeholder="••••••••" className={inp} />
        </div>
        <div>
          <label className="block text-xs font-mono uppercase tracking-widest text-[#888] mb-2">Neues Passwort</label>
          <input data-testid="new-password" type="password" required value={nw} onChange={(e) => setNw(e.target.value)} placeholder="Mind. 6 Zeichen" className={inp} />
        </div>
        <div>
          <label className="block text-xs font-mono uppercase tracking-widest text-[#888] mb-2">Neues Passwort bestätigen</label>
          <input data-testid="confirm-password" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" className={inp} />
        </div>
        <button type="submit" disabled={saving} data-testid="save-password" className="w-full rounded-full bg-white text-[#050505] py-3.5 font-medium hover:bg-[#d1d5db] transition-colors disabled:opacity-50">
          {saving ? "Speichern…" : "Passwort ändern"}
        </button>
      </form>

      <form onSubmit={saveCounter} data-testid="counter-form" className="max-w-md rounded-3xl border border-white/10 bg-[#0a0a0a] p-8 space-y-5">
        <div className="w-12 h-12 rounded-full border border-white/15 flex items-center justify-center text-white mb-2"><Hash size={20} /></div>
        <div>
          <p className="text-white font-medium mb-1">Kundennummern</p>
          <p className="text-xs text-[#888]" data-testid="next-customer-number">Nächste vergebene Nummer aktuell: {counter?.next_customer_number || "…"}</p>
        </div>
        <div>
          <label className="block text-xs font-mono uppercase tracking-widest text-[#888] mb-2">Nächste Kundennummer soll sein (z. B. 1500)</label>
          <input data-testid="next-customer-number-input" type="number" min="1" value={nextNumber} onChange={(e) => setNextNumber(e.target.value)} placeholder="z. B. 1500" className={inp} />
        </div>
        <button type="submit" disabled={savingCounter} data-testid="save-counter" className="w-full rounded-full bg-white text-[#050505] py-3.5 font-medium hover:bg-[#d1d5db] transition-colors disabled:opacity-50">
          {savingCounter ? "Speichern…" : "Übernehmen"}
        </button>
      </form>
    </div>
  );
}
